<!-- ./src/pages/admin/Products.vue -->
<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Parâmetros
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-textarea
              v-model="model.card1"
              label="Historia"
            ></v-textarea>
            <v-card>
              <v-card-title>
                <span class="headline">Cadastrar Imagens</span>
              </v-card-title>
              <v-layout row wrap>
                <v-flex sm12 md12>
                  <input
                      type="file"
                      ref="image"
                      accept="image/*"
                      :multiple="true"
                      @change="onFileChange"
                    >
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="headersImagem"
                :items="model.images"
              >
                <template slot="items" slot-scope="props2">
                  <td>{{ props2.item.descricao }}</td>
                  <td >
                    <v-btn icon class="mx-0" @click="deleteImage(props2.item)">
                      <v-icon color="pink">delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card>
            <v-btn @click="save();"> Salvar </v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import parameter from "@/services/parameter";

export default {
  name: "home",
  data() {
    return {
      search: "",
      snackbar: false,
      message: "",
      loading: true,
      dialog: false,
      dialogError: false,
      dialogConfirmation: false,
      excluindo: {},
      idZabbix: "",
      usuarios: [],
      model: {
        name: ""
      },
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Ações" }
      ],
      headersImagem: [{
          text: 'Nome Imagem',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Ações' }
      ],
    };
  },
  created() {
    parameter.getParameter().then(res => {
      this.model = res;
    });
  },
  methods: {
    save: function() {
      console.log(this.model);
      parameter.saveParameter(this.model).then(res => {
        console.log(res);
        if (res.data && res.data.error) {
          this.message = res.data.error.data;
          this.dialogError = true;
        }
      });
    },
    async deleteImage (item) {
      let res = await parameter.removeParamImage(item, this.model._id);
      parameter.getParameter().then(res => {
        this.model = res;
      });
    },
    
    async onFileChange($event){
      const files = $event.target.files || $event.dataTransfer.files;
      if (files) {
        var payload = new FormData();
        
        payload.set('param', this.model._id);
        if (files.length > 0) {
          for (var i = 0; i < files.length; i++) {
            var file = files[i];
            payload.append('filename', file);
          }
          let res = await parameter.saveParamImage(payload);
          this.model = await parameter.getParameter();
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/user/Params.vue